// extracted by mini-css-extract-plugin
export default {"component":"TopNavigator_component__29d1b"};